export enum Products {
  Dryers = 'DRYERS',
  Filters = 'FILTERS',
  DryersFilters = 'DRYERS_FILTERS',
  CompressedAirSolution = 'COMPRESSED_AIR_SOLUTION',
  NitrogenGenerator = 'NITROGEN_GENERATOR',
}
